import React from "react";
import CardItem from "./CardItem";
import "./Cards.css";

function Cards() {
  return (
    <div className="cards">
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards_items">
            <CardItem src="images/Headshot-3100ED.jpg" text="About Erin" path="/Information" />
            <CardItem src="images/Dr_B_headshot_1.png" text="Our Office" path="https://innovativehealthdrs.com/" />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
